import { useEffect, useState } from 'react';
import { LANGUAGE_CODE } from '../../../../constants/staticPageConstants';
import CMSPageDataServices from '../../services/cms-pages.service';
import { TOPICS, pageCategoryName } from '../constants';
import { LeftArticleContainer } from '../styles';
import { IRELATED_POSTS } from '../types';
import { getArticles } from '../util';

interface LHSProps {
  relatedPost: Array<IRELATED_POSTS> | null;
  popularPost: Array<IRELATED_POSTS> | null;
  interestedPost: Array<IRELATED_POSTS> | null;
  language: number;
  domainName: string;
}

export const LeftSideArticles = (params: LHSProps): JSX.Element => {
  const { relatedPost, popularPost, interestedPost, language, domainName } =
    params;
  return (
    <>
      {language === LANGUAGE_CODE['Hindi'] ? null : (
        <LeftArticleContainer>
          <div className=" mt-12 px-4 pr-8">
            <div className="">
              {getArticles(
                TOPICS[domainName]?.[pageCategoryName.default] || [],
                'BROWSE BY TOPICS'
              )}
              {getArticles(popularPost, 'POPULAR ARTICLES')}
              {getArticles(relatedPost, 'RELATED ARTICLES')}
              {getArticles(interestedPost, 'YOU MIGHT BE INTERESTED IN')}
            </div>
          </div>
        </LeftArticleContainer>
      )}
    </>
  );
};

export const KSA_LHS = ({
  domain,
  language,
}: {
  domain: number;
  language: number;
}): JSX.Element => {
  const [articleList, updateArticle] = useState([{ title: '', permalink: '' }]);

  useEffect(() => {
    const getArticle = async () => {
      const res = await CMSPageDataServices.getAllURLs(domain, language);
      const listData = await res.data;
      updateArticle([...listData]);
    };
    getArticle();
  }, []);

  return (
    <LeftArticleContainer>
      <div className=" mt-12 px-4 pr-8">
        {getArticles(articleList.slice(0, 10), 'RECENTLY PUBLISHED')}
      </div>
    </LeftArticleContainer>
  );
};
